/**
 * Search all children to find and return property value.
 */
export const deepFindProperty = (property, node, settings = {}) => {
  if (!node) return;
  if (Object.hasOwn(node, property)) {
    return node[property];
  }

  const { children } = node;
  if (!children) return;
  const { length } = children;
  if (!length) return;
  const { indexes = [] } = settings;
  for (let i = 0; i < length; i += 1) {
    if (indexes.length > 0 && !indexes.includes(i)) {
      // eslint-disable-next-line no-continue
      continue;
    }
    const found = deepFindProperty(property, children[i], settings);
    if (found) return found;
  };
};
